<template>
  <!-- Modal Definir Repetir Pedido -->
  <div id="ModalRepetirPedido" class="modal bottom-sheet">
    <div class="modal-content ">
      <div
        class="btn waves-effect waves-light cor-primaria-bg" @click="UltimoPedido()" style="padding: 0; width: 100%">
        <div class="">
          <div class="col s12" style="margin-left: auto;
      margin-right: auto; font-weight: bold">Visualizar último pedido
          </div>
        </div>
      </div>
      <div class="btn waves-effect waves-light btn-flat" @click="Menu()"
           style="padding: 0; padding-top: 5px;width: 100%">
        <div class="col s12" style="margin-left: auto; margin-right: auto; font-weight: bold">Fazer novo pedido
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "ModalRepetirPedido",
  data() {
    return {
      isLoading: false,
      fullPage: true
    }
  },
  async mounted() {
    $(document).ready(function () {
      $('#ModalRepetirPedido').modal();
    });
  },
  methods: {
    UltimoPedido() {
      this.$router.push("/" + this.$store.state.empresa_url + "/cliente-ultimo-pedido");
    },
    Menu() {
      $('#ModalRepetirPedido').modal();
      this.$router.push("/" + this.$store.state.empresa_url + "/menu");

      try{
        $('.materialboxed').materialbox();
        $("body").css({"overflow":"unset"});
      }catch (e) {
      }

    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Widgets/ModalRepetirPedido.vue